module.exports = __webpack_public_path__ + "img/camera-retro-duotone.64976efe.svg";